exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_PowerBI_Report_DmRbTRAzmIiI-TftH6kJ5{\n  height: 100%;\n  background-color: white;\n}", ""]);

// Exports
exports.locals = {
	"IA_PowerBI_Report": "IA_PowerBI_Report_DmRbTRAzmIiI-TftH6kJ5"
};